// The Place Order page for whatever patient the current route is about. Shared by
// the chart action bar and the progress note's "Ready to Place" pills, which used to
// derive it separately (and by the header link this ticket removed).
export function orderTestsPathFor(pathname: string): string | null {
  const patient = pathname.match(/^\/patients\/([^/]+)/)
  if (patient) return `/patients/${patient[1]}/order-tests`
  const call = pathname.match(/^\/call\/([^/]+)/)
  if (call) return `/call/${call[1]}/order-tests`
  return null
}

export const REFERRAL_START_PARAM = 'start'
export const REFERRAL_START_VALUE = 'referral'

/** The order page opened straight onto the referral fork (the chart's Referral button). */
export function referralStartPath(orderTestsPath: string): string {
  return `${orderTestsPath}?${REFERRAL_START_PARAM}=${REFERRAL_START_VALUE}`
}

/** Which OrderTests view a URL asks for. Anything but `?start=referral` is the catalog. */
export function startViewFor(search: string): 'catalog' | 'referralChoice' {
  return new URLSearchParams(search).get(REFERRAL_START_PARAM) === REFERRAL_START_VALUE
    ? 'referralChoice'
    : 'catalog'
}
